module.exports = __webpack_public_path__ + "img/footer-logo-bg.12bb68ef.svg";